import { useState } from "react";
import { ZoomInIcon, ZoomOutIcon, RotateCcwIcon } from "lucide-react";

import backend from "../../../../../backend/backend";

import "./ImagePreview.scss";

const ImagePreview = ({ path, workspaceId, projectUid }) => {
  const [zoom, setZoom] = useState(1);
  const [error, setError] = useState(false);

  const imageUrl = backend.getProjectFileDownloadUrl(workspaceId, projectUid, path);

  const handleZoomIn = () => {
    setZoom((prev) => Math.min(prev + 0.25, 3));
  };

  const handleZoomOut = () => {
    setZoom((prev) => Math.max(prev - 0.25, 0.25));
  };

  const handleReset = () => {
    setZoom(1);
  };

  const handleError = () => {
    setError(true);
  };

  if (error) {
    return (
      <div className="image_preview error">
        <p>Failed to load image</p>
      </div>
    );
  }

  return (
    <div className="image_preview">
      <div className="preview_toolbar">
        <button onClick={handleZoomOut} title="Zoom out" disabled={zoom <= 0.25}>
          <ZoomOutIcon size={16} />
        </button>
        <span className="zoom_level">{Math.round(zoom * 100)}%</span>
        <button onClick={handleZoomIn} title="Zoom in" disabled={zoom >= 3}>
          <ZoomInIcon size={16} />
        </button>
        <button onClick={handleReset} title="Reset zoom">
          <RotateCcwIcon size={16} />
        </button>
      </div>
      <div className="preview_container">
        <div
          className="image_wrapper"
          style={{ transform: `scale(${zoom})` }}
        >
          <img
            src={imageUrl}
            alt={path}
            onError={handleError}
          />
        </div>
      </div>
    </div>
  );
};

export default ImagePreview;
